import { Dispatch, SetStateAction } from "react";
import SearchBar from "../../components/SearchBar";
import { TableTitle } from "../../components/TableTitle";
import { configProps, Dropdowns } from "../../types";
import VisibleColumnsDropdown from "../../components/VisibleColumnsDropdown";
import { Button } from "primereact/button";
import { useAppDispatch } from "../../redux/store";
import { createFormSlice } from "../../redux/slices/createForm";
import FiltersDropdowns from "../../components/FiltersDropdowns.tsx";

type DriversToolbarProps = {
  config: configProps<"drivers">;
  globalFilterValue: string;
  setGlobalFilterValue: Dispatch<SetStateAction<string>>;
  visibleColumns: configProps<"drivers">["columns"];
  // columns: configProps<"drivers">["columns"];
  setVisibleColumns: Dispatch<
    SetStateAction<configProps<"drivers">["columns"]>
  >;
  dropdownConfigs: Pick<Dropdowns, "organizationalUsers">;
};

export default function DriversToolbar({
  config,
  globalFilterValue,
  setGlobalFilterValue,
  visibleColumns,
  setVisibleColumns,
  dropdownConfigs,
}: DriversToolbarProps) {
  const dispatch = useAppDispatch();

  const firstRow = (
    <div className="toolbar-first-row">
      <TableTitle title={config.title} />

      <div className="toolbar-row--inner-container">
        <Button
          label="Dodaj nowy"
          icon="pi pi-plus"
          iconPos="right"
          onClick={() => {
            dispatch(
              createFormSlice.actions.openForm({
                mode: "create",
              }),
            );
          }}
        />
      </div>
    </div>
  );

  const secondRow = (
    <div className="toolbar-second-row">
      <div className="toolbar-row--inner-container">
        <SearchBar
          globalFilterValue={globalFilterValue}
          setGlobalFilterValue={setGlobalFilterValue}
        />
        <FiltersDropdowns
          columns={config.columns}
          dropdownConfigs={dropdownConfigs}
        />
      </div>

      <VisibleColumnsDropdown<"drivers">
        allColumns={config.columns}
        visibleColumns={visibleColumns}
        setVisibleColumns={setVisibleColumns}
      />
    </div>
  );

  return (
    <div className="toolbar">
      {firstRow}
      {secondRow}
    </div>
  );
}
